var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row justify-content-start align-items-center"},[_c('h1',[_c('i',{class:_vm.iconeTituloTabela}),_c('span',{staticClass:"tabela-titulo"},[_vm._v(_vm._s(_vm.tituloTabela))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }